export default {
    isLoading: false,
    isAlert: false,
    isAlertText: '',
};
